import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=6ba9c165"
import script from "./EmergencyContact.vue?vue&type=script&lang=js"
export * from "./EmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports